// extracted by mini-css-extract-plugin
export var boldText = "_6k-4";
export var checkboxContainer = "_6k-6";
export var closeIcon = "_6k-i";
export var container = "_6k-0";
export var drawer = "_6k-8";
export var drawerContent = "_6k-9";
export var extraSmallText = "_6k-5";
export var fulfillmentGroupTable = "_6k-e";
export var largeText = "_6k-3";
export var loadingSpinnerContainer = "_6k-j";
export var mediumText = "_6k-2";
export var narrow = "_6k-f";
export var notificationLink = "_6k-l";
export var packageCheckIconContainer = "_6k-7";
export var slideoutHeaderActions = "_6k-g";
export var slideoutHeaderActionsShifted = "_6k-h";
export var slideoutHeaderContainer = "_6k-a";
export var slideoutModal = "_6k-c";
export var stickyHeaderWrapper = "_6k-b";
export var table = "_6k-k";
export var tableContainer = "_6k-d";
export var tertiaryText = "_6k-1";